import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

function EventAlert(props) {
  function close() {
    if (props.hideModal) {
      props.hideModal();
    }
  }
 
  return (
    <>
      <Transition appear show={true} as={Fragment}>
        <Dialog as="div" className="relative z-[999999]" onClose={close}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full alert-modal max-w-md transform overflow-hidden rounded-md bg-[#2E2842] p-4 py-8 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  ></Dialog.Title>

                  <div className="head text-white">Booking is closed for this date</div>
                  {/* <button onClick={switchHotel} className="confirm mt-6 text-white">Go out of the hotel</button> */}
                  <button onClick={close} className="cancel mt-4 text-white">Got it.</button>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default EventAlert;
